import { convertStringToSlug } from './generateProductSlug';
export const generateUrlBrandDetail = (id: string, name: string, lang?: string) => {

  const strToSlug = convertStringToSlug(name);

  if (!strToSlug) return '';
  return `/thuong-hieu/${strToSlug}-b${id}${(lang && lang !== 'vi') ? `?lang=${lang}` : ''}`;
}